<template>
  <div>
    <!-- <div class="mynotice">
      <div class="m_info">
        <div>
          <span class="m_num">139</span>
          <span class="m_txt">剧本</span>
        </div>
        <div>
          <span class="m_num">139</span>
          <span class="m_txt">剧本</span>
        </div>
      </div>
      <div class="m_btn">去处理</div>
    </div> -->
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { getMCNTips } from '@/api/auditcont'

  export default {
    data(){
      return{
        requestTime:60*1000,
        key:'audittips'
      }
    },
    mounted(){
      // this.getUnAuditMcn()
    },
    methods:{
      ...mapMutations(['setMcn']),
      getUnAuditMcn(){
        getMCNTips().then(res=>{
          if(res.code==1&&res.result){
            var unplay = res.result.text*1
            var unvideo = res.result.video*1
            var unmate = res.result.richText*1
            this.$store.commit('SET_MCN', {text:unplay,video:unvideo,mate:unmate})
            if(unplay>0||unvideo>0||unmate>0){
              this.openNoti(unplay,unvideo,unmate)
              this.msgtips(unplay,unvideo,unmate)
            }else if(unplay==0&&unvideo==0&&unmate==0){
              this.$notification.close(this.key)
            }

            setTimeout(()=>{
              this.getUnAuditMcn()
            },this.requestTime)
          }
        })
      },
      openNoti(unplay,unvideo,unmate){
        var key = this.key
        this.$notification.open({
          message:'待处理审核信息',
          placement:'bottomRight',
          description: h=>{
            return h(
              'div',
              {
                'attrs':{
                  'class':'mynotice'
                },
              },
              [
                h('div',{'attrs':{'class':'m_info'}},[
                  h('div',null,[
                    h('span',{'attrs':{'class':'m_num'}},unplay),
                    h('span',{'attrs':{'class':'m_txt'}},'剧本')
                  ]),
                  h('div',null,[
                    h('span',{'attrs':{'class':'m_num'}},unvideo),
                    h('span',{'attrs':{'class':'m_txt'}},'视频')
                  ]),
                  h('div',null,[
                    h('span',{'attrs':{'class':'m_num'}},unmate),
                    h('span',{'attrs':{'class':'m_txt'}},'素材')
                  ])
                ]),
                h('div',{
                  'attrs':{'class':'m_btn'},
                  on:{
                    click:()=>{
                      this.$notification.close(key)
                      this.$router.push({
                        path:`/auditcont/auditcontList`
                      })
                    }
                  }},'去处理')
              ]
            )
          },
          duration: 0,
          key,
        })
      },
      msgtips(unplay,unvideo,unmate){
        if(!!window.Notification){
          if(Notification.permission=='granted'){
            // 同意直接弹
            this.notiMsg(unplay,unvideo,unmate)
          }else{
            Notification.requestPermission(res=>{
              if(!('permission' in Notification)){
                Notification.permission = res
              }
              if(res=='granted'){
                  this.notiMsg(unplay,unvideo,unmate)
              }
            })
          }
        }
      },
      notiMsg(unplay,unvideo,unmate){
        var self = this
        var playstr = ''
        if(unplay>0){
          playstr = unplay+'个剧本'
        }
        var videostr = ''
        if(unvideo>0){
          videostr = unvideo+'个视频'
        }
        var matestr = ''
        if(unmate>0){
          matestr = unmate+'个素材'
        }
        var body = '您有'+playstr+videostr+matestr+'待处理审核'
        // var pass = "https://cms-medias.jindashi.cn/data/admin/file/test/f77d70b97a3b46779b254e81de7c8bd7.png";
        var unpass = 'https://cms-medias.jindashi.cn/data/admin/file/test/6f9a8baa0f594c3e8196bf9e37dfa470.png'
        var noti = new Notification('待处理审核信息',{
          body:body,
          icon:unpass,
          tag:new Date().getTime()
        })
        noti.onclick = function(event){
          window.focus()
          noti.close()
        }
      }
    },
    watch:{
      '$store.state.user.auditTips'(val){
        if(val){
          this.getUnAuditMcn()
        }
      }
    }
  }
</script>

<style lang="less">

.mynotice{
  .m_info{
    display:flex;
    flex-flow:row nowrap;
    padding:20px 0;
    margin-top:10px;
    border-top:1px solid #e9e9e9;
    border-bottom:1px solid #e9e9e9;
    div{
      align-items: center;
      flex:1;
      width:50%;
      display:flex;
      flex-flow: column;
      border-right:1px solid #e9e9e9;
      .m_num{
        color:#108EE9;
        font-size:24px;
        font-weight:600;
      }
      .m_txt{
        color:rgba(0,0,0,0.85);
        font-size:14px;
      }
      &:nth-last-child(1){
        border-right:0px;
      }
    }
  }
  .m_btn{
    width: 100%;
    height:50px;
    text-align: center;
    line-height:50px;
    color:#108EE9;
    font-size:14px;
    cursor: pointer;
  }
}
</style>